import { styled } from "@linaria/react"
import * as Tabs from "@radix-ui/react-tabs"
import { Link } from "@tanstack/react-router"

import * as textStyles from "@/styles/textStyles.ts"

export const Root = Tabs.Root

export const List = styled(Tabs.List)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 18px;
`

export const Trigger = styled(Tabs.Trigger)`
  ${textStyles.smallFontSize};

  height: 32px;
  padding: 0;

  color: var(--secondary-text-color);
  border-bottom: 1px solid transparent;

  &:hover, &[data-state="active"] {
    color: var(--text-color);
    border-bottom-color: var(--text-color-20);
  }

  &:focus-visible {
    outline: none;
    border-bottom-color: var(--main-color);
  }

  &[data-disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
`

export const BorderlessTabsTrigger = styled(Trigger)`
  &:hover, &[data-state="active"] {
    border-bottom-color: transparent;
  }
`

export const Content = styled(Tabs.Content)`
  height: 100%;
  outline: none;
`

export const TabLink = styled(Link)`
  color: inherit;

  &:hover {
    color: inherit;
  }

  white-space: nowrap;
`
